import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
        InnerBlocks,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-category', {
        // built-in attributes
        title: 'Card Category',
        description: 'Custom Card Category',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            buttonText: {
                type: 'string',
                default: 'See more'
            },
            count: {
                type: 'string',
                default: '160+'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                link,
                image,
                alt,
                count,
                classes
            } = attributes;

            const MY_TEMPLATE = [
                [ 'core/heading', { placeholder: 'Card title', className: 'card-title' } ],
                [ 'core/group', { className: 'card-description' }, [
                    [ 'core/paragraph', { placeholder: 'Card text' } ]
                ] ]
            ];

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({image: image.sizes.full.url});
                setAttributes({alt: image.alt});
            }

            function onCountChange(count) {
                setAttributes({count: count});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <div>
                                    { image && 
                                        <div>
                                            <figure>
                                                <img src={image} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ image: '' })} className="button">Remove</Button>
                                            </div>
                                            <br></br>
                                        </div>
                                
                                    }
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                                </div>
                            ) } />
                        <br />
                        <p><strong>Enter url: (ex: /camps/)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <a className={ "card card-category" + (classes ? ' ' + classes : '') }>
                    <div className="card-img-top">
                        <img className="cover-image" src={ image } alt={ alt } />
                        <RichText
                            key="editable"
                            tag="div"
                            className="count-bubble"
                            placeholder="160+"
                            value={ count }
                            onChange={ onCountChange }/>
                    </div>
                    <div className="card-body">
                        <InnerBlocks template={ MY_TEMPLATE } />
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                count,
                classes
            } = attributes;

            return (
                <a href={ link } className={ "card card-category" + (classes ? ' ' + classes : '') }>
                    <div className="card-img-top">
                        <img className="lozad cover-image" data-src={ image } alt={ alt } />
                        <div className="count-bubble">{ count }</div>
                    </div>
                    <div className="card-body">
                        <InnerBlocks.Content />
                    </div>
                </a>
            );
        },
    });
}